import { render, staticRenderFns } from "./editMenuDialog.vue?vue&type=template&id=0ae61f77&scoped=true&"
import script from "./editMenuDialog.vue?vue&type=script&lang=js&"
export * from "./editMenuDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae61f77",
  null
  
)

export default component.exports